import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { NavLink } from "react-router-dom";

const hpMainSlider = {
    dots: false,
    autoplay: true,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };


const Sports_Fitness1 = () => {
    return (
        <>
        <div id="maincarousel">
        <div className="container">
          <div className="row">
                              <div className="col-lg-3">
                              <div class="sc-gWXbKe hoZTIr __pf" id="__pf">
                              <div data-pf-type="Block" className="sc-bilyIR cCHonK pf-16_">
                    <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-17_">
                      <i className="sc-gIDmLj huzWMp pf-18_ pfa pfa-bars" data-pf-type="Icon" />
                      <a
                        data-link="inherit"
                        href="/sports-fitness-outdoors"
                        target="_self"
                        style={{color:'#fff'}}
                      >
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-19_">
                        Sports & Fitness 
                        </span>
                      </a>
                    </h3>
                    <div className="sc-bilyIR cCHonK pf-20_">
                    <NavLink 
                            to={'/outdoor-recreation'}
                            exact
                          >
                    
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-21_">
                        <img
                          src="	https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659607933844a9SeiP.png"
                          srcSet="	https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659607933844a9SeiP.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-22_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-24_">
                        Outdoor Recreation
                        </span>
                      </h3>
                      </NavLink>
                      </div>
                    <div className="sc-bilyIR cCHonK pf-25_"
                    >
                      <NavLink 
                            to={'/camping-hiking'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-26_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659608112051n6T4Qg.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659608112051n6T4Qg.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-27_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-29_">
                        Camping Hiking
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    
                    <div
                      
                      className="sc-bilyIR cCHonK pf-30_"
                    >
                      <NavLink 
                            to={'/climbing'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-31_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596081998623O4OhY.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596081998623O4OhY.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-32_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-34_">
                        Climbing
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-35_"
                    >
                      <NavLink 
                            to={'/exercise-fitness'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-36_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596083925207sO0OG.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596083925207sO0OG.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-37_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-39_">
                        Exercise Fitness
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-40_"
                    >
                      <NavLink 
                            to={'/hand-tools'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-41_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596087920195vGZSG.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596087920195vGZSG.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-42_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-44_">
                        Hand Tools
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-45_"
                    >
                      <NavLink 
                            to={'/accessories'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-46_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659608982524GyEXLk.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659608982524GyEXLk.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-47_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-49_">
                        Accessories
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                  </div>
                  </div>
                              </div>
            <div className="col-lg-9"> <Slider {...hpMainSlider}>
            <div className="item">
                <a href="/football" className="banner"><img src="	https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16599594918266o82mi.png" style={{width: '100%'}} className='image_banner' alt="首页面（新）" /></a>
            </div>
            <div className="item">
                <a href="/outdoor-recreation" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659936021942CMNXX0.png" style={{width: '100%' }} className='image_banner' alt="Modern L-Shaped Sofa Price" /></a>
            </div>
            {/* <div className="item">
                <a href="/products/sofa" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/1657711628171PZ80nC.png" style={{width: '100%'}} alt="Sofa S1015" /></a>
            </div> */}
            
            
            
        </Slider></div>
          </div>
        </div>
        <div className='container' style={{marginTop:'30px'}}>
            <div className='row sc-gWXbKe hoZTIr __pf' id="__pf">
                <div className='col-lg-6'>
                <a href ="/sports-gadgets">
                <div data-pf-type="Column" className="sc-hAcGzb bAQARH pf-57_sports">
                <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-58_">
                <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-60_"><br />
                <span style={{'font-weight': 'bold'}}></span>
                <br />

                </span>
                </h3>
                </div> 
                </a>
                </div>
                <div className='col-lg-6 ' >
                <a href="/exercise-fitness">
                <div data-pf-type="Column" className="sc-hAcGzb bAQARH pf-61_sports">
                    <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-62_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-64_">
                        
                        <br />
                        <span style={{ fontWeight: 700 }}></span>
                        <br />
                        </span>
                    </h3>
                    </div>
</a>
                </div>
            </div>
        </div>
       
        </div>
        </>

    )
}

export default Sports_Fitness1;
